import { AnyObject, BaseEntity, dateTimeIOSString, Pagination } from "./base.model";
import { CompanyStore } from "./company.store.model";
import { Period } from "./report.model";

// uid could be email, mobile or device
export interface SurveyEventSubmit {
  status: SurveyEventStatusEnum;
  surveyEventId: string;
  companyId: string;
  id: string;
  uid: string;
  email?: string;
  name?: string;
  device?: string;
  viewedAt?: dateTimeIOSString;
  answeredAt?: dateTimeIOSString;
  sentAt?: dateTimeIOSString;
  answers?: AnyObject;
  deviceId?: string;
  completionTime?: number;
  ip?: string;
  invalid?: boolean;
  invalidReason?: string;
  storeId?: string;
}

export enum SurveyEventStatusEnum {
  "draft" = "draft",
  "sent" = "sent",
  "viewed" = "viewed",
  "answered" = "answered",
}

export interface SurveyEvent extends BaseEntity {
  id: string;
  surveyId: string;
  companyId: string;
  survey: Survey;
}

export interface Survey extends BaseEntity {
  id: string;
  name: string;
}